var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 56,
    viewBox: "0 0 33 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7071 28.7071C33.0976 28.3166 33.0976 27.6834 32.7071 27.2929L26.3431 20.9289C25.9526 20.5384 25.3195 20.5384 24.9289 20.9289C24.5384 21.3195 24.5384 21.9526 24.9289 22.3431L30.5858 28L24.9289 33.6569C24.5384 34.0474 24.5384 34.6805 24.9289 35.0711C25.3195 35.4616 25.9526 35.4616 26.3431 35.0711L32.7071 28.7071ZM0 29H32V27H0V29Z",
    fill: "#F3F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLong);
export default __webpack_public_path__ + "static/media/arrow-right-long.daa9103e3b5fc78fb4e9e24b168db671.svg";
export { ForwardRef as ReactComponent };